import { styled } from "@/stitches/config"

export const STabs = styled("div", {})
